import { defineMessages } from 'react-intl';

export const mentionsMessages: {
	mentionFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagTitleTwoMentions: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	mentionFlagTitleMultipleMentions: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	mentionFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	taskMentionFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	taskMentionFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagFailedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagFailedTitleWithoutDisplayName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagFailedDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagDoNotNotifyButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagAcknowledgeButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagNoPermissionsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagTwoNoPermissionsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagMultipleNoPermissionsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagNoSpaceOrParentPermissionsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagTwoNoSpaceOrParentPermissionsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagMultipleNoSpaceOrParentPermissionsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	taskMentionFlagNoPermissionsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagNoSpaceOrParentPermissionsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagNoPermissionsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	taskMentionFlagNoPermissionsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagNoPermissionsParentRestrictionsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	taskMentionFlagNoPermissionsParentRestrictionsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagNoPermissionsSpaceRestrictionsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	taskMentionFlagNoPermissionsSpaceRestrictionsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	taskMentionFlagNoPermissionsParentSpaceRestrictionsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagShareNowButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagDontShareButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagShareFailedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionFlagShareFailedDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deletedMentionFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deletedMentionFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deletedMentionFlagConfirmation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dontNotifyFailureTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dontNotifyFailureDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	mentionFlagTitle: {
		id: 'mentions-notifications.mention.flag.title',
		defaultMessage: '{displayName} will be notified',
		description: 'Title text for the mention flag when a user is mentioned',
	},
	mentionFlagTitleTwoMentions: {
		id: 'mentions-notifications.mention.flag.title.two.mentions',
		description: 'Flag title to inform that two people have been mentioned',
		defaultMessage: '{displayName} and {somebodyElse} will be notified',
	},
	mentionFlagTitleMultipleMentions: {
		id: 'mentions-notifications.mention.flag.title.multiple.mentions',
		description: 'Flag title to inform that multiple people have been mentioned',
		defaultMessage: `{displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}} will be notified`,
	},
	mentionFlagDescription: {
		id: 'mentions-notifications.mention.flag.description',
		defaultMessage: 'We’ll let them know you mentioned them.',
		description: 'Body text for the mention flag when a user is mentioned',
	},
	taskMentionFlagTitle: {
		id: 'mentions-notifications.task.mention.flag.title',
		defaultMessage: 'We’ll notify {displayName}',
		description: 'Title text for the mention flag when a user is mentioned in a task',
	},
	taskMentionFlagDescription: {
		id: 'mentions-notifications.task.mention.flag.description',
		defaultMessage: 'We’ll let them know you assigned them a task.',
		description: 'Body text for the mention flag when a user is mentioned in a task',
	},
	mentionFlagFailedTitle: {
		id: 'mentions-notifications.mention.flag.failed.title',
		defaultMessage: 'We weren’t able to notify {displayName}',
		description: 'Title text for flag when the mention request fails',
	},
	mentionFlagFailedTitleWithoutDisplayName: {
		id: 'mentions-notifications.mention.flag.failed.generic.title',
		defaultMessage: 'We weren’t able to notify the user',
		description: 'Title text without display name for flag when the mentioned user request fails',
	},
	mentionFlagFailedDescription: {
		id: 'mentions-notifications.mention.flag.failed.description',
		defaultMessage: 'In order to notify them, you’ll need to @ mention them again.',
		description: 'Description text for flag when the mention request fails',
	},
	mentionFlagDoNotNotifyButton: {
		id: 'mentions-notifications.mention.flag.do.not.notify.button',
		defaultMessage: 'Don’t notify',
		description: 'Button in the mention flag to prevent a notification from sending a mention',
	},
	mentionFlagAcknowledgeButton: {
		id: 'mentions-notifications.mention.flag.acknowledge.button',
		defaultMessage: 'OK',
		description: 'Button in the mention flag to acknowledge you will be sending a mention',
	},
	mentionFlagNoPermissionsTitle: {
		id: 'mentions-notifications.mention.flag.no.permissions.title',
		defaultMessage: 'Share with {displayName}?',
		description:
			'Title text for mention flag for a user who does not have permissions to access the page',
	},
	mentionFlagTwoNoPermissionsTitle: {
		id: 'mentions-notifications.mention.flag.no.permissions.two.mentions.title',
		defaultMessage: 'Share with {displayName} and {somebodyElse}?',
		description:
			'Title text for mention flag for two users who do not have permissions to access the page',
	},
	mentionFlagMultipleNoPermissionsTitle: {
		id: 'mentions-notifications.mention.flag.no.permissions.multiple.mentions.title',
		defaultMessage:
			'Share with {displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}}',
		description:
			'Title text for mention flag for multiple users who do not have permissions to access the page',
	},
	mentionFlagNoSpaceOrParentPermissionsTitle: {
		id: 'mentions-notifications.mention.flag.no.space.parent.permissions.title',
		defaultMessage: '{displayName} won’t be notified',
		description:
			'Title text for mention flag for a user who does not have permissions to access the parent page or space',
	},
	mentionFlagTwoNoSpaceOrParentPermissionsTitle: {
		id: 'mentions-notifications.mention.flag.no.space.parent.permissions.two.mentions.title',
		defaultMessage: '{displayName} and {somebodyElse} won’t be notified',
		description:
			'Title text for mention flag for two users who do not have permissions to access the parent page or space',
	},
	mentionFlagMultipleNoSpaceOrParentPermissionsTitle: {
		id: 'mentions-notifications.mention.flag.no.space.parent.permissions.multiple.mentions.title',
		defaultMessage:
			'{displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}} won’t be notified',
		description:
			'Title text for mention flag for multiple users who do not have permissions to access the parent page or space',
	},
	taskMentionFlagNoPermissionsTitle: {
		id: 'mentions-notifications.task.mention.flag.no.permissions.title',
		defaultMessage: 'Share with {displayName}?',
		description:
			'Title text for task mention flag for a user who does not have permissions to access the page',
	},
	mentionFlagNoSpaceOrParentPermissionsDescription: {
		id: 'mentions-notifications.mention.flag.no.space.parent.permissions.description',
		defaultMessage:
			'They need space or parent access, so we can’t let them know you mentioned them.',
		description:
			'Description text for mention flag for a user who does not have permissions to access the parent page or space',
	},
	mentionFlagNoPermissionsDescription: {
		id: 'mentions-notifications.mention.flag.no.permissions.description',
		defaultMessage:
			'They don’t have access to this content, so we can’t let them know you mentioned them.',
		description:
			'Description text for mention flag for a user who does not have permissions to access the page',
	},
	taskMentionFlagNoPermissionsDescription: {
		id: 'mentions-notifications.task.mention.flag.no.permissions.description',
		defaultMessage:
			'They don’t have access to this content, so we can’t assign them a task or notify them.',
		description:
			'Description text for task mention flag for a user who does not have permissions to access the page',
	},
	mentionFlagNoPermissionsParentRestrictionsDescription: {
		id: 'mentions-notifications.mention.flag.no.permissions.parent.restrictions.description',
		defaultMessage:
			'They don’t have access to a parent item, so we can’t let them know you mentioned them.',
		description:
			'Description text for mention flag for a user who does not have permissions to access the page because of parent restrictions',
	},
	taskMentionFlagNoPermissionsParentRestrictionsDescription: {
		id: 'mentions-notifications.task.mention.flag.no.permissions.parent.restrictions.description',
		defaultMessage:
			'They don’t have access to a parent item, so we can’t assign them a task or notify them.',
		description:
			'Description text for task mention flag for a user who does not have permissions to access the page because of parent restrictions',
	},
	mentionFlagNoPermissionsSpaceRestrictionsDescription: {
		id: 'mentions-notifications.mention.flag.no.permissions.space.restrictions.description',
		defaultMessage:
			'They don’t have access to the space, so we can’t let them know you mentioned them.',
		description:
			'Description text for mention flag for a user who does not have permissions to access the page because of space restrictions',
	},
	taskMentionFlagNoPermissionsSpaceRestrictionsDescription: {
		id: 'mentions-notifications.task.mention.flag.no.permissions.space.restrictions.description',
		defaultMessage:
			'They don’t have access to the space, so we can’t assign them a task or notify them.',
		description:
			'Description text for task mention flag for a user who does not have permissions to access the page because of space restrictions',
	},
	taskMentionFlagNoPermissionsParentSpaceRestrictionsDescription: {
		id: 'mentions-notifications.task.mention.flag.no.permissions.parent.space.restrictions.description',
		defaultMessage:
			'They don’t have access to a parent item or space, so we can’t assign them this task or notify them.',
		description:
			'Description text for task mention flag for a user who does not have permissions to access the page because of space or parent page restrictions',
	},
	mentionFlagShareNowButton: {
		id: 'mentions-notifications.mention.flag.share.now.button',
		defaultMessage: 'Share now',
		description: 'Button in the mention flag to share page with mentioned user',
	},
	mentionFlagDontShareButton: {
		id: 'mentions-notifications.mention.flag.dont.share.button',
		defaultMessage: 'Don’t share',
		description:
			'Button in the mention flag to acknowledge the flag and not share the page with mentioned user',
	},
	mentionFlagShareFailedTitle: {
		id: 'mentions-notifications.mention.flag.share.failed.title',
		defaultMessage: 'We weren’t able to share this content with {displayName}',
		description: 'Title text for mention flag after page is not shared',
	},
	mentionFlagShareFailedDescription: {
		id: 'mentions-notifications.mention.flag.share.failed.description',
		defaultMessage: 'Please try again later.',
		description: 'Description text for mention flag after page is not shared',
	},
	deletedMentionFlagTitle: {
		id: 'mentions-notifications.mention.flag.deleted.title',
		defaultMessage: 'You just removed an @ mention',
		description: 'Title text for mention flag after mention has been deleted',
	},
	deletedMentionFlagDescription: {
		id: 'mentions-notifications.mention.flag.deleted.description',
		defaultMessage: '{name} won’t be notified anymore',
		description: 'Description text for mention flag after mention has been deleted',
	},
	deletedMentionFlagConfirmation: {
		id: 'mentions-notifications.mention.flag.deleted.confirmation',
		defaultMessage: 'Got it',
		description: 'Text for user confirming knowledge that they will not notify the mentioned user',
	},
	dontNotifyFailureTitle: {
		id: 'mentions-notifications.mention.flag.do.not.notify.failure.title',
		defaultMessage: 'Something went wrong',
		description: 'Title text for flag when the do not notify request fails',
	},
	dontNotifyFailureDescription: {
		id: 'mentions-notifications.mention.flag.do.not.notify.failure.description',
		defaultMessage: 'Due to an error, we weren’t able to cancel this notification. ',
		description: 'Description text for flag when the do not notify request fails',
	},
});
